<template>
  <div class="gc-cost-wrap">
    <van-nav-bar
      :border="false"
      title="收入信息"
      left-arrow
      @click-left="$router.back()"
    />
    <div class="tab-title" v-if="canDepIncome">
      <div
        class="item"
        :class="{ active: status == 0 }"
        @click="handleUserCost"
      >
        个人收入
      </div>
      <div class="item" :class="{ active: status == 1 }" @click="handleDepCost">
        部门收入
      </div>
      <!-- <div class="item" :class="{'active':status==2}" @click="handleComCost">公司收入</div> -->
    </div>
    <div class="cost-box-wrap">
      <div class="item" v-for="(item, index) in costList" :key="index">
        <div class="info-wrap">
          <span class="t">{{ item.Name }}</span>
          <span>{{ item.Sysno }}</span>
        </div>
        <!-- <div class="remarks">由财务部发起的全效智能体数据录入工作</div> -->
      </div>
    </div>
    <div class="cost-bottom-wrap">
      收入合计：<span>{{ allMoney }}元</span>
    </div>
  </div>
</template>

<script>
import { hasPerm } from '@/utils/perm';

export default {
  data() {
    return {
      costList: [],
      allMoney: 0,
      status: this.$route.query.status ? this.$route.query.status : 0,
    };
  },
  computed: {
    // 部门/公司收入属他人敏感数据，按 RBAC 权限展示，不再依赖 legacy isDep 标志
    canDepIncome() {
      return hasPerm("analytics.team.read");
    },
    canComIncome() {
      return hasPerm("analytics.tenant.read");
    },
  },
  mounted() {
    // URL 参数降级：无对应报表权限时强制回落个人收入，防止 ?status=1/2 越权
    if (this.status == 1 && !this.canDepIncome) {
      this.status = 0;
    } else if (this.status == 2 && !this.canComIncome) {
      this.status = 0;
    }
    if (this.status == 1) {
      this.WebGetBUserProjectItemLst();
    } else if (this.status == 2) {
      this.WebGetComUserDcMoneyInfoLst();
    } else {
      this.WebGetUserDcMoneyInfoLst();
    }
  },
  methods: {
    // 个人收入
    WebGetUserDcMoneyInfoLst() {
      let data = {
        UserSysno: localStorage.getItem("UserSysno"),
        StartDate: this.$route.query.date || "",
        EndDate: this.$route.query.date || ""
      };
      this.$baseajax.normalJsonp(
        this.$base.baseapi + "/WebGetUserDcMoneyInfoLst",
        data,
        res => {
          console.log(res);
          res = res.WebGetUserDcMoneyInfoLstResult;
          if (res.ResponseCode == 1) {
            this.costList = res.ItemLst;
            this.allMoney = res.ResponseMessage;
          }
        },
        err => {
        }
      );
    },
    // 部门收入
    WebGetBUserProjectItemLst() {
      let data = {
        DepSysno: localStorage.getItem("GovDepSysno"),
        StartDate: this.$route.query.date || "",
        EndDate: this.$route.query.date || ""
      };
      this.$baseajax.normalJsonp(
        this.$base.baseapi + "/WebGetBUserProjectItemLst",
        data,
        res => {
          console.log(res);
          res = res.WebGetBUserProjectItemLstResult;
          if (res.ResponseCode == 1) {
            this.costList = res.ItemLst;
            this.allMoney = res.ResponseMessage;
          }
        },
        err => {
        }
      );
    },
    // 公司收入详情
    WebGetComUserDcMoneyInfoLst() {
      let data = {
        ComSysno: localStorage.getItem("UserComSysno"),
        StartDate: this.$route.query.date || "",
        EndDate: this.$route.query.date || ""
      };
      this.$baseajax.normalJsonp(
        this.$base.baseapi + "/WebGetComUserDcMoneyInfoLst",
        data,
        res => {
          console.log(res);
          res = res.WebGetComUserDcMoneyInfoLstResult;
          if (res.ResponseCode === 1) {
            this.costList = res.ItemLst;
            this.allMoney = res.ResponseMessage;
          }
        },
        err => {
        }
      );
    },
    handleUserCost() {
      this.status = 0;
      this.WebGetUserDcMoneyInfoLst();
    },
    handleDepCost() {
      this.status = 1;
      this.WebGetBUserProjectItemLst();
    },
    handleComCost() {
      this.status = 2;
      this.WebGetComUserDcMoneyInfoLst();
    }
  }
};
</script>

<style lang="less" scoped>
.gc-cost-wrap {
  padding-bottom: 1.6rem;
}

.tab-title {
  display: flex;
  justify-content: space-around;
  background: #fff;
  padding: 0.3rem 0 0.2rem;
  box-shadow: 0rem 0rem 0.28rem 0rem rgba(211, 47, 47, 0.14);

  .item {
    font-size: 0.4rem;
    padding-bottom: 0.15rem;
    color: #333;
    position: relative;

    &.active {
      color: #4c52be;

      &:after {
        position: absolute;
        left: 50%;
        margin-left: -0.64rem;
        bottom: 0;
        content: "";
        width: 1.28rem;
        height: 0.08rem;
        background-color: #4c52be;
        border-radius: 0.03rem;
      }
    }
  }
}

.cost-box-wrap {
  margin: 0.28rem 0.28rem 0;
  padding: 0.5rem 0.5rem 0.1rem;
  background-color: #ffffff;
  box-shadow: 0rem 0rem 0.28rem 0rem rgba(211, 47, 47, 0.14);
  border-radius: 0.27rem;

  .title {
    padding-bottom: 0.4rem;
    font-size: 0.47rem;
    font-weight: 700;
    color: #333333;
    // border-bottom: 1px solid #eee;
  }

  .item {
    padding: 0.5rem 0.1rem;
    border-top: 1px solid #efefef;
    font-size: 0.37rem;
    color: #333333;

    &:first-child {
      border-top: none;
    }

    .info-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .remarks {
      margin-top: 0.25rem;
      padding: 0.2rem 0.35rem;
      font-size: 0.33rem;
      color: #888888;
      background-color: #f0f0f0;
      border-radius: 0.13rem;
    }
  }
}

.cost-bottom-wrap {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding-left: 0.9rem;
  padding-right: 0.9rem;
  height: 1.3rem;
  line-height: 1.3rem;
  background-color: #ffffff;
  font-size: 0.37rem;
  color: #4c52be;
  box-shadow: 0rem 0.01rem 0.13rem 0rem rgba(32, 23, 147, 0.17);
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/views/my/Income.vue